import { render, staticRenderFns } from "./GuavaVsGovavaView.vue?vue&type=template&id=8ba53d46&scoped=true"
import script from "./GuavaVsGovavaView.vue?vue&type=script&lang=js"
export * from "./GuavaVsGovavaView.vue?vue&type=script&lang=js"
import style0 from "./GuavaVsGovavaView.vue?vue&type=style&index=0&id=8ba53d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba53d46",
  null
  
)

export default component.exports